import { action  } from "satcheljs";
import { ITeamInfoEntity } from "src/client/react/src/staffhub/sh-models";

const deleteSchedule = action(
    "DELETE_SCHEDULE",
    (
        teamInfo: ITeamInfoEntity, teams: ITeamInfoEntity[], onDeleteScheduleSuccess: (deletedTeam: ITeamInfoEntity) => void, onDeleteScheduleFailure: (error: any) => void
    ) => ({
        teamInfo, teams, onDeleteScheduleSuccess, onDeleteScheduleFailure
    })
);

export default deleteSchedule;